import { Accordion } from 'admin-web-ui'
import React from 'react'
import { HydratedUserInfo } from '../../types'
import { DisplayList } from '../components'
import { FundingSourcesList } from './FundingSourcesList'
import { VirtualCardsList } from './VirtualCardsList'

interface Props
  extends Pick<
    HydratedUserInfo,
    'username' | 'virtualCards' | 'fundingSources'
  > {}

export const VirtualCardsSection: React.FC<Props> = ({
  username,
  virtualCards,
  fundingSources,
}) => {
  return virtualCards?.length || fundingSources?.length ? (
    <Accordion title="Virtual Cards">
      <DisplayList>
        {virtualCards?.length ? (
          <VirtualCardsList virtualCards={virtualCards} username={username} />
        ) : null}
        {fundingSources?.length ? (
          <FundingSourcesList fundingSources={fundingSources} />
        ) : null}
      </DisplayList>
    </Accordion>
  ) : null
}
